import { render, staticRenderFns } from "./turnover-list.vue?vue&type=template&id=1fa6e5d8&scoped=true&"
import script from "./turnover-list.vue?vue&type=script&lang=js&"
export * from "./turnover-list.vue?vue&type=script&lang=js&"
import style0 from "./turnover-list.vue?vue&type=style&index=0&id=1fa6e5d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa6e5d8",
  null
  
)

export default component.exports